module.exports = __webpack_public_path__ + "static/media/logo-ue.3eb27d8f.png";